import { useShortIdContext } from '@air/provider-short-id';

import { useSubmitNewDiscussion } from '~/swr-hooks/discussions/useSubmitNewDiscussion';

/**
 * Public share-link surfaces create discussions through the link's shortId, read from
 * ShortIdProvider — mounted under every public asset modal — rather than sniffed from the URL
 * (the share-link preview iframe and the editor's Edit-tab canvas don't live on `/a/…` routes).
 */
export const usePublicSubmitNewDiscussion = () => {
  const { shortId } = useShortIdContext();

  return useSubmitNewDiscussion({ shortId });
};
